import { AjvError, withTheme } from '@rjsf/core';
// @ts-ignore
import { Theme as AntDTheme } from '@rjsf/antd';
import React, { useMemo, useRef, useState } from 'react';
import { FieldProps } from 'formik';

import { JSONSchema7 } from 'json-schema';
import { debounce } from 'lodash';

const Form = withTheme(AntDTheme);

type JsonSchemaFormComponentProps = {
  schema: JSONSchema7;
  formData: any;
};

export const JsonSchemaFormComponent: React.ComponentType<
  FieldProps & JsonSchemaFormComponentProps
> = ({
  field: { name, value }, // { name, value, onChange, onBlur }
  form: {
    setFieldValue,
    setFieldError,
    setErrors,
    setFieldTouched,
    validateForm,
  },
  schema,
}) => {
  const formRef = useRef<{
    state: { errors: AjvError[]; formData: any };
  }>({ state: { formData: {}, errors: [] } });
  const formData = useMemo(() => ({ ...value }), [value]);

  const updateForm = () => {
    const { formData, errors } = formRef.current.state;
    setFieldValue(name, { ...formData }, false);
    if (errors && errors.length) {
      setFieldError(name, (errors || []).map(x => x.message).join('\n'));
      setFieldTouched(name, true, false);
    } else {
      setErrors({});
      validateForm();
    }
  };
  const [debouncedUpdateForm] = useState(() => debounce(updateForm, 300));

  return (
    <Form
      className="json-schema-form"
      // @ts-ignore
      ref={formRef}
      tagName="div"
      schema={schema}
      formData={formData}
      onChange={debouncedUpdateForm}
      omitExtraData={true}
      liveOmit={true}
      liveValidate={true}
      showErrorList={false}
      onBlur={() => {
        updateForm();
      }}
    >
      <></>
    </Form>
  );
};
